import { ItemImage } from "@coworker/apprestructured/src/shared/components/item-cards/ItemImage/ItemImage";
import { ItemName } from "@coworker/apprestructured/src/shared/components/item-cards/ItemName/ItemName";
import { ItemDescription } from "@coworker/apprestructured/src/shared/components/item-cards/ItemDescription/ItemDescription";
import { ItemStockAndEds } from "@coworker/apprestructured/src/shared/components/item-cards/ItemStockAndEds/ItemStockAndEds";
import { ItemDelivery } from "@coworker/apprestructured/src/shared/components/item-cards/ItemDelivery/ItemDelivery";
import { ItemCard } from "@coworker/apprestructured/src/shared/components/item-cards/ItemCard/ItemCard";
import { ItemNoWithCopy } from "@coworker/apprestructured/src/shared/components/item-cards/ItemNoWithCopy/ItemNoWithCopy";
import { ItemPieces } from "@coworker/apprestructured/src/shared/components/item-cards/ItemPieces/ItemPieces";

import { ItemWithPieces } from "@coworker/apprestructured/src/shared/types/item";
import styles from "../../../styles/common-styles.module.css";

interface ItemCardWithPiecesProps {
  item: ItemWithPieces;
}

export const ItemCardWithPieces = ({ item }: ItemCardWithPiecesProps) => {
  return (
    <ItemCard>
      <div className={styles["item-card-root-row"]}>
        <ItemImage imageUrl={item.smallImageUrl || item.imageUrl || ""} />
        <div className={styles["item-card-root-column"]}>
          <ItemName name={item.name} />
          <ItemNoWithCopy itemNo={item.noFormatted} />
          <ItemDescription description={item.description || ""} />
          <ItemPieces pieces={item.pieces ?? 0} />
          <ItemStockAndEds itemNo={item.no} itemType={item.type} />
          <ItemDelivery itemNo={item.no} />
        </div>
      </div>
    </ItemCard>
  );
};
